var _g, _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeIllustrationInductionStove(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 95,
    viewBox: "0 0 103 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4821_17217)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 47.3906,
    cy: 47.5201,
    rx: 26.9883,
    ry: 26.8814,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 47.3889,
    cy: 47.5199,
    rx: 18.9436,
    ry: 18.8686,
    fill: "url(#paint0_linear_4821_17217)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.7076 48.1707H57.5628V46.9975H58.2185C58.9355 46.9975 59.5177 46.4164 59.5177 45.7035C59.5177 44.9893 58.9342 44.4094 58.2185 44.4094L36.8089 44.4082C36.4608 44.4082 36.1324 44.5437 35.8872 44.7903C35.6421 45.0369 35.5073 45.3641 35.5097 45.7108C35.5146 46.4201 36.098 46.9963 36.8089 46.9963H37.2232V48.1695L35.0771 48.1707C34.3883 48.1707 33.8281 48.7286 33.8281 49.4147C33.8281 50.1008 34.3883 50.6587 35.0771 50.6587H37.222V52.7707C37.222 55.8471 39.7345 58.3508 42.8243 58.3508H51.9577C55.0476 58.3508 57.56 55.8482 57.56 52.7707V50.6587H59.7049C60.3937 50.6587 60.9538 50.1008 60.9538 49.4147C60.9551 48.7299 60.3962 48.1707 59.7073 48.1707L59.7076 48.1707ZM36.4889 45.7059C36.4889 45.6204 36.5208 45.5399 36.582 45.4801C36.6421 45.419 36.723 45.3861 36.8088 45.3861H58.2184C58.3949 45.3861 58.537 45.5289 58.537 45.7035C58.537 45.8792 58.3936 46.0209 58.2184 46.0209H57.0724L37.7133 46.0221H36.8088C36.6335 46.0209 36.4901 45.8792 36.4889 45.7059L36.4889 45.7059ZM35.0769 49.6834C34.9286 49.6834 34.8085 49.5638 34.8085 49.416C34.8085 49.2683 34.9286 49.1487 35.0769 49.1487H37.2218V49.6834L35.0769 49.6834ZM56.581 52.772C56.581 55.3101 54.5071 57.3755 51.9592 57.3755H42.8257C40.2776 57.3755 38.2039 55.3099 38.2039 52.772V46.9988H56.5813L56.581 52.772ZM59.7076 49.6834H57.5627V49.1487H59.7076C59.8559 49.1487 59.976 49.2683 59.976 49.4161C59.976 49.5626 59.8547 49.6834 59.7076 49.6834V49.6834Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3965 41.9839C47.6674 41.9839 47.8868 41.7654 47.8868 41.4956V35.2745C47.8868 35.0047 47.6674 34.7861 47.3965 34.7861C47.1256 34.7861 46.9062 35.0047 46.9062 35.2745V41.4956C46.9062 41.7654 47.1256 41.9839 47.3965 41.9839Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0645 41.9848C44.3353 41.9848 44.5547 41.7663 44.5547 41.4965V36.628C44.5547 36.3582 44.3353 36.1396 44.0645 36.1396C43.7936 36.1396 43.5742 36.3582 43.5742 36.628V41.4965C43.5742 41.7663 43.7936 41.9848 44.0645 41.9848Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.7
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7129 41.9848C50.9838 41.9848 51.2032 41.7663 51.2032 41.4965V36.628C51.2032 36.3582 50.9838 36.1396 50.7129 36.1396C50.442 36.1396 50.2227 36.3582 50.2227 36.628V41.4965C50.2227 41.7663 50.442 41.9848 50.7129 41.9848Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.7
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4821_17217",
    x: 0.402344,
    y: 0.638672,
    width: 93.9766,
    height: 93.7627,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.114844 0 0 0 0 0.222396 0 0 0 0 0.4375 0 0 0 0.54 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4821_17217"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4821_17217",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4821_17217",
    x1: 62.3235,
    y1: 29.3594,
    x2: 20.1719,
    y2: 42.7755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D3970"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B1529"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIllustrationInductionStove);
export default __webpack_public_path__ + "static/media/home_illustration_induction_stove.5547674f2d4dbbab2eb848229802521e.svg";
export { ForwardRef as ReactComponent };